module.exports = __webpack_public_path__ + "static/media/search-engine-optimization.ef2d012d.svg";